import axios from "axios";
import { forceLogoutAndRedirect } from "./force_logout";


export const setAuthToken = (token) => {
  if (token) {
    const bearer = token.startsWith("Bearer ") ? token : `Bearer ${token}`;
    axios.defaults.headers.common["Authorization"] = bearer;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export const signup = (userData) => axios.post("/api/users/register", userData);

export const login = (userData) => axios.post("/api/users/login", userData);

// ✅ If you ever need to fetch a specific user, do it with params or a real route.
// Otherwise, you can remove this.
export const fetchUser = (id) => axios.get("/api/users/dashboard", { params: { id } });

// ✅ Current user (JWT identifies them)
export const fetchDashboardUser = () => axios.get("/api/users/dashboard");

axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      forceLogoutAndRedirect();
      return; // stop here (we already redirected)
    }
    return Promise.reject(err);
  }
);